// This file is AUTOGENERATED, do not edit it manually!!!

export const taskDetails = {
    actualCompletionDate: 'Tatsächl. Abschlussdatum: ',
    actualCompletionDateFull: 'Tatsächliches Abschlussdatum',
    AutoAssign_Issue: 'Neue Probleme automatisch zuweisen:',
    AutoAssign_Note: 'Jede Aktivität, die diesem Projekt hinzugefügt wird, wird dem ausgewählten Mitglied zugewiesen.',
    AutoAssign_Request: 'Neue Anfragen automatisch zuweisen:',
    AutoAssign_Task: 'Neue Aufgaben automatisch zuweisen:',
    AutoAssign_Title: 'Automatische Zuweisung',
    BaselineCaptureLabel: 'Baseline für Erfassung',
    BaselineOverwrite: 'Aktuelle Baseline überschreiben?',
    BaselineOverwriteDescription: 'Sie haben bereits eine Baseline für dieses Projekt. Wenn Sie fortfahren, wird die aktuelle Baseline verworfen.',
    BaselineRecaptureLabel: 'Baseline überschreiben',
    BaselineSuccess: 'Die Baseline wurde erfolgreich erfasst.',
    Billed: 'Abgerechnet',
    Billing: 'Abrechnung',
    BillingSettingsTitle: 'Abrechnungseinstellungen',
    BillingTypeNotBillable: 'Nicht abrechnungsfähig',
    BillingTypeProjectBillingSettings: 'Projekt-Abrechnungseinstellungen',
    btnNotifications: 'Benachrichtigungen',
    BudgetLeft: ' übrig',
    BudgetTotal: ' gesamt',
    By: 'von ',
    Change: 'ändern',
    Close: 'Schließen',
    ConfirmStatusDialogTitle: '\"{0}\" abschließen?',
    DayPluralFormat: '1#{0} tag#{0} tage',
    Days: '({0}t)',
    DeleteActivity: 'Aktivität löschen',
    DeleteProject: 'Projekt löschen',
    Dependencies_Count: '1#{0} Abhängigkeit#{0} Abhängigkeiten',
    DifferPermissionsMessage: 'zeigt an, dass die Berechtigungen des aktuellen Projektmitglieds sich von den Berechtigungen der Standardrolle unterscheiden',
    DueIn_Ok: 'fällig in {0}',
    DueIn_Trouble: '{0} überfällig',
    DueIn_Warning: 'heute fällig',
    EditRoleAndPermissions: 'Rolle und Berechtigungen bearbeiten',
    endDate: 'Geplantes Enddatum: ',
    endDateFull: 'Geplantes Enddatum',
    endLessThenStartMsg: '\'Enddatum\' darf nicht kleiner sein als \'Startdatum\'',
    estimatedHours: '1# geschätzte Stunde# geschätzte Stunden',
    ExportToMsProject: 'Als MS Projekt exportieren',
    Fields: '1#{0} Feld#{0} Felder',
    FillCustomFields: '{0} muss noch ausgefüllt werden',
    Follow: 'Folgen',
    HideCustomFields: 'Benutzerdefinierte Felder ausblenden',
    hoursLeft: '1# Stunde übrig# Stunden übrig',
    HoursOf: 'Std von ',
    HtmlField_ReadAll: '... alle lesen',
    ImDoneText: 'Ich bin fertig',
    IsMilestone: 'Das ist ein Meilenstein',
    issue: 'Problem',
    MarkAsMilestone: 'Als Meilenstein markieren',
    MemberPermission_Add: 'Hinzufügen',
    MemberPermission_Add_For_Someone_Else: 'Für jemand anderes hinzufügen',
    MemberPermission_Add_Own: 'Eigene hinzufügen',
    MemberPermission_CanManageProjectMembers: 'Mitglieder verwalten',
    MemberPermission_CanViewMembersAndAssignees: 'Ansehen',
    MemberPermission_Delete: 'Löschen',
    MemberPermission_Delete_All: 'Alle löschen',
    MemberPermission_Edit: 'Bearbeiten',
    MemberPermission_Edit_All: 'Alle bearbeiten',
    MemberPermission_Edit_Assigned: 'Zugewiesene bearbeiten',
    MemberPermission_Manage_Assigned: 'Beauftragte verwalten',
    MemberPermission_View_All: 'Alle ansehen',
    MemberPermission_View_and_Manage: 'Anzeigen und verwalten',
    MemberPermission_View_Assigned: 'Zugewiesene ansehen',
    MemberPermissions_MembersAndAssigneesTitle: 'Mitglieder & Beauftragte:',
    MemberPermissions_TasksTitle: 'Aktivitäten:',
    MemberPermissions_ThisProjectTitle: 'Projekt:',
    MemberPermissions_TimeEntriesTitle: 'Zeiteinträge:',
    Members: '1#{0} Mitglied#{0} Mitglieder',
    On: ' am ',
    OwnBudget: 'Budget für diese Aktivität:',
    PercentDone: '1#% fertig#% fertig',
    PermissionsSettingsTitle: 'Berechtigungen für {0}',
    project: 'Projekt',
    Project_NotFound_Message: 'Das gesuchte Projekt konnte nicht gefunden werden oder Sie sind nicht zugriffsberechtigt. Wenden Sie sich bei Rückfragen hierzu bitte an Ihren {brandName}-Administrator. Der Objektschlüssel ist {0}.',
    Project_NotFound_Title: 'Gesuchtes Projekt nicht gefunden',
    Project_WasCompleted_Ok: 'Projekt wurde <b>{0} vor</b> dem geplanten Enddatum abgeschlossen',
    Project_WasCompleted_Trouble: 'Projekt wurde <b>{0} nach</b> dem geplanten Enddatum abgeschlossen',
    Project_WasCompleted_Warning: 'Projekt wurde am geplanten Enddatum abgeschlossen',
    RatioOfMoneySpent: '1#{0} von {1} verbraucht#{0} von {1} verbraucht',
    RepeatActivity: 'Wiederholen',
    request: 'Anfrage',
    ResumeWorkHelpText: 'Sie haben Ihre Aufgabe abgeschlossen. ',
    ResumeWorkText: 'Arbeit fortsetzen',
    RoleTitle: 'Rolle in diesem Projekt',
    Save: 'Speichern',
    Set_actualCompletionDate: 'Tatsächliches Abschlussdatum festlegen',
    Set_budget: 'Budget festlegen',
    Set_categoryId: 'Kategorie festlegen',
    Set_customerId: 'Kunde festlegen',
    Set_dates: 'Datum oder Dauer festlegen',
    Set_description: 'Beschreibung hinzufügen',
    Set_endDate: 'Geplantes Enddatum festlegen',
    Set_estimatedHours: 'Geschätzten Stunden festlegen',
    Set_hoursLeft: 'Verbleibende Stunden festlegen',
    Set_labor_budget: 'Budget festlegen',
    Set_portfolioId: 'Portfolio festlegen',
    Set_short_hoursLeft: 'Verbleibende Stunden festlegen',
    SetAsRootLevel: 'Als höchste Aktivität festlegen',
    SetCompleted: 'Als abgeschlossen markieren',
    short_hoursLeft: '1# Stunde übrig# Stunden übrig',
    ShowCustomFields: 'Benutzerdefinierte Felder anzeigen',
    Spent: '1#Std aufgewendet#Std aufgewendet',
    Status: 'Status: ',
    task: 'Aufgabe',
    Task_NotFound_Message: 'Die gesuchte Aktivität konnte nicht gefunden werden oder Sie sind nicht zugriffsberechtigt. Wenden Sie sich bei Rückfragen hierzu bitte an Ihren {brandName}-Administrator. Der Objektschlüssel ist {0}.',
    Task_NotFound_Title: 'Gesuchte Aktivität nicht gefunden',
    Task_WasCompleted_Ok: 'Aktivität wurde <b>{0} vor</b> dem geplanten Enddatum abgeschlossen',
    Task_WasCompleted_Trouble: 'Aktivität wurde <b>{0} nach</b> dem geplanten Enddatum abgeschlossen',
    Task_WasCompleted_Warning: 'Aktivität wurde am geplanten Enddatum abgeschlossen',
    today: 'Heute',
    UnFollow: 'Nicht mehr folgen',
    WindowUnload_UnsavedChanges: ' Sie haben nicht gespeicherte Änderungen. Möchten Sie die Seite wirklich verlassen?',
};
